// @vendors
const Immutable = require('immutable');
const { get } = require('lodash');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    goalType: 'others',
    error: null,
    isFetchingDetail: false,
    name: {
        error: false,
        isUpdating: false,
        value: '',
    },
    objectiveEndDate: '',
    periodicTransfer: {
        amount: 0,
        code: '',
        nextDate: '',
    },
    probability: '',
    assetAllocation: [],
    keyFigures: {
        valuation: 0,
        netReturn: 0,
        simpleReturn: 0,
        deposits: 0,
        withdrawals: 0,
        investedAmount: 0,
        initialInvestment: 0,
    },
    editAmountModal: {
        objectiveAmount: 0,
        showModal: false,
        isUpdating: false,
        resetAmount: 0,
    },
    state: {},
    portfolioId: '',
    portfolioStartDate: '',
    isSuccess: false,
    fromGoalPGNotification: false,
});

const extractPortfolioDetail = (state, response) => {
    const portfolioId = state.get('portfolioId');
    return get(response, 'roboAdvisor.portfolioOverviews', []).find(
        portfolio => portfolio.id === portfolioId,
    );
};

const sortByAssetClassId = assetAllocation => {
    const sortedAssetAllocation = assetAllocation.sort((a, b) => {
        if (a.assetClassId < b.assetClassId) return -1;
        if (a.assetClassId > b.assetClassId) return 1;
        return 0;
    });

    return sortedAssetAllocation;
};

const parseResponse = (state, portfolioData) => {
    const {
        keyFigures,
        goalInformation,
        recurringTransfers,
        assetAllocation,
        hasGoal,
        created,
        id,
        state: portfolioState,
    } = portfolioData || {};

    if (hasGoal) {
        return state.merge({
            goalType: goalInformation.goalType,
            keyFigures,
            state: portfolioState,
            portfolioId: id,
            isFetchingDetail: false,
            name: {
                error: false,
                isUpdating: false,
                value: goalInformation.name,
            },
            editAmountModal: {
                objectiveAmount: goalInformation.goalAmount,
            },
            objectiveEndDate: goalInformation.goalDate,
            periodicTransfer: {
                amount: get(recurringTransfers, 'amount', 0),
                periodicity: get(recurringTransfers, 'recurringCode', ''),
                nextDate: get(recurringTransfers, 'nextTransferDate', ''),
            },
            probability: goalInformation.probability,
            assetAllocation: Immutable.fromJS(
                sortByAssetClassId(assetAllocation),
            ),
            portfolioStartDate: created,
            isSuccess: true,
        });
    } else {
        return state.merge({ isFetchingDetail: false, error: true });
    }
};

const RAObjectiveDetials = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_OBJECTIVE_DETAILS_RESET:
            return initialState;
        case actionTypes.RA_OBJECTIVE_DETAILS_SET_PORTFOLIO_DATA:
            return parseResponse(state, action.payload.data);
        case actionTypes.BROKER_GET_MY_INVESTMENTS_REQUEST:
            return state.merge({ isFetchingDetail: true, error: null });
        case actionTypes.BROKER_GET_MY_INVESTMENTS_FAILURE:
            return state.merge({ isFetchingDetail: false, error: true });
        case actionTypes.BROKER_GET_MY_INVESTMENTS_SUCCESS:
            if (!!state.get('portfolioId')) {
                return parseResponse(
                    state,
                    extractPortfolioDetail(state, action.payload),
                );
            } else {
                return state;
            }
        case actionTypes.RA_OBJECTIVE_NAME_UPDATE_REQUEST:
            return state.mergeIn([name], {
                error: false,
                isUpdating: true,
            });
        case actionTypes.RA_OBJECTIVE_NAME_UPDATE_FAILURE:
            return state.merge({
                name: {
                    error: true,
                    isUpdating: false,
                },
            });
        case actionTypes.RA_OBJECTIVE_NAME_UPDATE_SUCCESS:
            if (
                action.payload &&
                action.payload.data &&
                action.payload.data.goalAmount
            ) {
                return state.mergeIn(['editAmountModal'], {
                    objectiveAmount: action.payload.data.goalAmount,
                });
            } else {
                return state.merge({
                    name: {
                        error: false,
                        isUpdating: false,
                        value: action.payload.data.name,
                    },
                });
            }
        case actionTypes.RA_OBJECTIVE_EDIT_AMOUNT_MODAL_SHOW:
            return state.mergeIn(['editAmountModal'], {
                resetAmount: action.payload.currentGoalAmount,
                showModal: true,
            });
        case actionTypes.RA_OBJECTIVE_EDIT_AMOUNT_MODAL_HIDE:
            return state.mergeIn(['editAmountModal'], {
                showModal: false,
            });
        case actionTypes.RA_OBJECTIVE_DETAILS_SET_FROM_PG_NOTIFICATION:
            return state.merge({
                fromGoalPGNotification: true,
            });
        case actionTypes.RA_OBJECTIVE_RESET_AMOUNT_VALUE:
            return state.mergeIn(['editAmountModal'], {
                resetAmount: action.payload.currentGoalAmount,
            });
        case actionTypes.RA_OBJECTIVE_DETAILS_HEADER_TITLE_ERROR_ENABLED:
            return state.setIn(['name', 'error'], true);
        default:
            return state;
    }
};

module.exports = RAObjectiveDetials;
